import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  navbarSettings: service(),
  storeCache: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Disbursement Summary');
  },

  model() {
    return this.storeCache.findAll('fund').then((funds) => {
      return {
        funds,
      };
    });
  },
});
